module.exports = __webpack_public_path__ + "static/media/page-next-over.4bc993da.svg";